module.exports = __webpack_public_path__ + "img/head.c294c943.png";